import React from "react"

export type ReactUseState<T> = {
  state: T
  setState: React.Dispatch<React.SetStateAction<T>>
}

export const IsSearchingContext = React.createContext<ReactUseState<boolean>>(
  {} as ReactUseState<boolean>
)

export const IsRestoreSearchingContext = React.createContext<
  ReactUseState<boolean>
>({} as ReactUseState<boolean>)

export const GridInitializedContext = React.createContext<
  ReactUseState<boolean>
>({} as ReactUseState<boolean>)

export const searchDyTypeContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const searchDyFromContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const searchDyToContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const juchuBusyoCdContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const ninusiCdContext = React.createContext<
  ReactUseState<string | undefined>
>({} as ReactUseState<string | undefined>)

// TODO:API確定後、responseの型に変更
export const SearchResultContext = React.createContext<any[] | undefined>([])

/**
 * 車番連絡表印刷のProvider
 */
export const SyabanRenrakuhyoProvider: React.FC<{
  isSearching: ReactUseState<boolean>
  isRestoreSearching: ReactUseState<boolean>
  gridInitialized: ReactUseState<boolean>
  SearchResult: Array<Object> | undefined
  searchDyType: ReactUseState<string | null | undefined>
  searchDyFrom: ReactUseState<string | null | undefined>
  searchDyTo: ReactUseState<string | null | undefined>
  juchuBusyoCd: ReactUseState<string | null | undefined>
  ninusiCd: ReactUseState<string | undefined>
}> = (props) => {
  return (
    <IsSearchingContext.Provider value={props.isSearching}>
      <SearchResultContext.Provider value={props.SearchResult}>
        <GridInitializedContext.Provider value={props.gridInitialized}>
          <IsRestoreSearchingContext.Provider value={props.isRestoreSearching}>
            <searchDyTypeContext.Provider value={props.searchDyType}>
              <searchDyFromContext.Provider value={props.searchDyFrom}>
                <searchDyToContext.Provider value={props.searchDyTo}>
                  <juchuBusyoCdContext.Provider value={props.juchuBusyoCd}>
                    <ninusiCdContext.Provider value={props.ninusiCd}>
                      {props.children}
                    </ninusiCdContext.Provider>
                  </juchuBusyoCdContext.Provider>
                </searchDyToContext.Provider>
              </searchDyFromContext.Provider>
            </searchDyTypeContext.Provider>
          </IsRestoreSearchingContext.Provider>
        </GridInitializedContext.Provider>
      </SearchResultContext.Provider>
    </IsSearchingContext.Provider>
  )
}
